import axios from 'axios';

const getWeight = async (id) => {
	let weight;
	await axios
		.get(`${process.env.NEXT_PUBLIC_SERVER_API}/api/other/get-weight/${id}`)
		.then((res) => {
			weight = res.data;
		})
		.catch((err) => console.log(err));

	return weight;
};

export default getWeight;
